<template>
  <div>
    <!--Loading-->
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>

    <PageTitle title="Subject" />
    <div class="columns">
      <div class="column is-12">
        <div class="card">
          <div class="card-content">
            <b-field>
              <b-button @click="addNewGradeSubject()" type="is-info" size="is-small">New mapping</b-button>
            </b-field>

            <!--Set Subject-->
            <b-modal :active.sync="modalGradeSubjectActive"
            has-modal-card
            trap-focus
            :destroy-on-hide="true"
            aria-role="dialog"
            aria-modal>
              <set-grade-subject :grade_subject_id="edit_subject_id" @over="modalGradeSubjectActive = false"></set-grade-subject>
            </b-modal>

            <div class="columns">
              <div class="column is-4">
                <b-field label="Subject">
                  <b-select @input="filterBy()" v-model="filter.subject" expanded placeholder="Filter by subject here">
                    <option v-for="subject in fetchSubjects" :key="subject._id" :value="subject._id">{{subject.name}}</option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="Grade">
                  <b-select @input="filterBy()" v-model="filter.grade" expanded placeholder="Filter by grade here">
                    <option v-for="grade in fetchGrades" :key="grade._id" :value="grade._id">{{grade.name}}</option>
                  </b-select>
                </b-field>
              </div>
            </div>

            <b-table :paginated="true" :per-page="20" :pagination-simple="true" :data="fetchGradeSubjects">
              <b-table-column v-slot="props" field="grade" label="Grade">{{props.row.grade.name}}</b-table-column>
              <b-table-column v-slot="props" field="subject" label="Subject">{{props.row.subject.name}}</b-table-column>
              <b-table-column v-slot="props" field="remarks" label="Remarks">{{props.row.remarks}}</b-table-column>
              <b-table-column v-slot="props" field="status" label="Status">
                <b-tag :type="props.row.status ? 'is-success' : 'is-danger'">
                  {{ props.row.status ? 'Active' : 'Inactive' }}
                </b-tag>
              </b-table-column>
              <b-table-column v-slot="props" field="created_at" label="Created At">{{$common.formatDate(props.row.created_at)}}</b-table-column>
              <b-table-column v-slot="props" field="is_locked" label="Locked">
                <b-icon :icon="props.row.is_locked ? 'check' : 'close'" :type="props.row.is_locked ? 'is-success' : 'is-danger'"></b-icon>
              </b-table-column>
              <b-table-column v-slot="props" field="actions" label="Action">
                <div class="buttons">
                  <b-button @click="$router.push({ name : 'gradesubjectdetail', params : { id : props.row._id } })" type="is-dark" size="is-small" icon-left="eye"></b-button>
                  <b-button @click="editSubject(props.row._id)" type="is-primary" size="is-small" icon-left="pencil"></b-button>
                  <b-button @click="deleteThisSubject(props.row._id)" type="is-danger" size="is-small" icon-left="delete"></b-button>
                </div>
              </b-table-column>
              <template slot="empty">
                <empty-table message="No subjects created."></empty-table>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//Vuex
import {mapGetters, mapActions} from 'vuex'
import PageTitle from '@/components/PageTitle'
import EmptyTable from '@/components/EmptyTable'
import SetGradeSubject from '@/components/GradeSubject/SetGradeSubject'

export default {
  name : 'GradeSubject',
  components : {
    PageTitle, EmptyTable, SetGradeSubject
  },
  data(){
    return {
      isLoading : false,
      modalGradeSubjectActive : false,
      edit_subject_id : null,
      filter : {
        subject : null,
        grade : null
      }
    }
  },
  computed : {
    ...mapGetters(['fetchGradeSubjects', 'getTeacherToken', 'fetchGrades', 'fetchSubjects'])
  },
  methods : {
    ...mapActions(['loadGradeSubjects', 'deleteGradeSubject', 'loadSubjects', 'loadGrades']),
    addNewGradeSubject(){
      this.modalGradeSubjectActive = true
    },
    editSubject(id){
      this.modalGradeSubjectActive = true
      this.edit_subject_id = id
    },
    filterBy(){
      this.isLoading = true
      this.loadGradeSubjects({ 
        token : this.getTeacherToken, 
        filter : this.filter
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        this.$buefy.toast.open({
          message: err.response.data,
          type: 'is-danger'
        })
      })
    },
    deleteThisSubject(id){
      this.$buefy.dialog.confirm({
        title: 'Warning',
        message : 'Are you sure want to delete this grade subject mapping permanently?',
        type : 'is-danger',
        onConfirm: () => {
          this.deleteGradeSubject({
            token : this.getTeacherToken,
            id
          }).then(() => {
            this.$buefy.toast.open({
              message: 'Grade Subject mapping deleted successfully',
              type: 'is-success'
            })
          }).catch(err => {
            this.$buefy.toast.open({
              message: err.response.data,
              type: 'is-danger'
            })
          })
        }
      })
    }
  },
  async created(){
    this.isLoading = true
    this.loadGrades({
      token : this.getTeacherToken
    })
    this.loadSubjects({
      token : this.getTeacherToken
    })

    try{
      await this.loadGradeSubjects({ token : this.getTeacherToken })
    }catch(err){
      this.$buefy.toast.open({
        message: err.response.data,
        type: 'is-danger'
      })
    }
    this.isLoading = false
  }
  
}
</script>